export default {
    debounceImmediate: true,
    deepWatchDataDepth: 0,
    deepWatchOptions: true,
    debounce: 0
};
